import BaseModel from './BaseModel'
import {action, makeObservable, observable} from 'mobx'
import {post} from '../common/requester'

export default class BillingDetail extends BaseModel {
    constructor() {
        super()

        makeObservable(this, {
            id: observable,
            company_id: observable,

            billing_group_id: observable,
            billing_group: observable,

            billing_type_id: observable,
            billing_type: observable,

            object_id: observable,
            object: observable,
            description: observable,

            company_user_id: observable,
            company_user: observable,

            amount: observable,
            notes: observable,

            is_paid: observable,
            payment_date: observable,
            payment_method: observable,
            is_approved: observable,

            rec_user_id: observable,
            rec_date: observable,

            cheque_upload: observable,
            currency: observable,
            cheques: observable,
            trainings: observable,

            changeAmount: action,
            saveNote: action,
            pay: action,
            approve: action,
            decline: action,
        })
    }

    id = 0
    company_id = 0

    billing_group_id = 0
    billing_group = {}

    billing_type_id = 0
    billing_type = {}

    object_id = 0
    object = {}
    description = ''

    company_user_id = 0
    company_user = {}

    amount = 0
    notes = ''

    is_paid = false
    payment_date = null
    payment_method = ''
    is_approved = false

    rec_user_id = 0
    rec_date = null

    cheque_upload = null
    currency = {}
    cheques = []
    trainings = {}

    async changeAmount() {
        const res = await post('manager/billing/change-amount', {
            billing_id: this.id,
            amount: this.amount
        }).catch(err => console.error('--change amount error', err))

        if (res?.billing) {
            this.fromJson(res.billing)
        }

        return res
    }

    async saveNote() {
        const res = await post('manager/billing/save-note', {
            billing_id: this.id,
            notes: this.notes
        }).catch(err => console.error('--save notes error', err))

        if (res?.billing) {
            this.fromJson(res.billing)
        }

        return res
    }

    async pay() {
        let ret = null

        if (this.payment_method === 'transfer') {
            if (!this.cheque_upload) {
                return Promise.reject('cheque_required')
            }

            ret = await post(
                'manager/billing/pay-with-cheque',
                this
            ).catch(err => console.error('--pay error', err))
        } else {
            ret = await post('manager/billing/pay', {
                billing_id: this.id
            }).catch(err => console.error('--pay error', err))
        }

        if (!ret?.billing) {
            return Promise.reject('error')
        }

        this.fromJson(ret.billing)

        return ret
    }

    async approve() {
        const res = await post('manager/billing/approve_telegram', {
            b_id: this.id
        }).catch(err => console.error('--approve error', err))

        if (res?.billing) {
            this.fromJson(res.billing)
        }

        return res
    }

    async decline() {
        const res = await post('manager/billing/deny_telegram', {
            b_id: this.id
        }).catch(err => console.error('--decline error', err))

        if (res?.billing) {
            this.fromJson(res.billing)
        }

        return res
    }
}